import { TextQueryValue } from "nystem-components";

const ReferenceQueryValue = (props) => <TextQueryValue {...props} />;

export default ReferenceQueryValue;
